// extracted by mini-css-extract-plugin
module.exports = {"MegaHero":"az_ukb","ContentContainer":"az_vkb"};